// withPopupScrollable.tsx
import React, { useState, useEffect } from "react";
import { ScrollView, Keyboard, Dimensions, ViewStyle } from "~/ui/primitives";
import { useSafeAreaInsets } from "~/ui/safe-area";
import { Flex } from "~components/El";

type Mode = "center" | "bottom";

interface Options {
    mode?: Mode;
    maxHeightRatio?: number; // 默认 0.85
}

export function withPopupScrollable<P>(
    Component: React.ComponentType<P>,
    options: Options = {}
) {
    const { mode = "bottom", maxHeightRatio = 0.85 } = options;

    return (props: P) => {
        const insets = useSafeAreaInsets();
        const screenHeight = Dimensions.get("window").height;

        const [keyboardHeight, setKeyboardHeight] = useState(0);

        /** 监听键盘 */
        useEffect(() => {
            const showSub = Keyboard.addListener("keyboardWillShow",(e) => setKeyboardHeight(e.endCoordinates.height));

            const hideSub = Keyboard.addListener("keyboardWillHide", () => setKeyboardHeight(0));

            return () => {
                showSub.remove();
                hideSub.remove();
            };
        }, []);

        /** 中心弹窗最大高度（居中对称必须高度不能超过屏幕） */
        const centerStyle: ViewStyle = {
            maxHeight: screenHeight * maxHeightRatio,
        };

        /** 底部弹窗最大高度（底部弹窗不允许超过屏幕的 85%） */
        const bottomStyle: ViewStyle = {
            maxHeight: screenHeight * maxHeightRatio,
            paddingBottom: keyboardHeight + insets.bottom,
        };

        const containerStyle = mode === "center" ? centerStyle : bottomStyle;

        return (
            <Flex
                flexDirection="column"
                width="100%"
                style={containerStyle}
            >
                <ScrollView
                    showsVerticalScrollIndicator={false}
                    showsHorizontalScrollIndicator={false}
                    bounces={false}
                    keyboardShouldPersistTaps="handled"
                    style={{ overflowX: "hidden", minWidth: 0 }}
                >
                    <Component {...props} />
                </ScrollView>
            </Flex>
        );
    };
}
